/**
 * TrendModa - Flash İndirim Geri Sayım
 */
(function () {
  'use strict';

  function getTargetDate(endDateStr) {
    if (endDateStr) {
      var d = new Date(endDateStr);
      if (!isNaN(d.getTime())) return d;
    }
    // Default: yarın gece 00:00
    var midnight = new Date();
    midnight.setDate(midnight.getDate() + 1);
    midnight.setHours(0, 0, 0, 0);
    return midnight;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function updateCountdown(el, targetDate, intervalId) {
    var diff = targetDate.getTime() - Date.now();

    if (diff <= 0) {
      // Interval'ı temizle (memory leak engeli)
      clearInterval(intervalId.id);
      // Sayaç bittiğinde reload yerine "Fırsat Bitti" mesajı göster
      el.innerHTML = '<span class="flash-countdown__expired">Kampanya Sona Erdi</span>';
      return;
    }

    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    var h = el.querySelector('.flash-countdown__hours');
    var m = el.querySelector('.flash-countdown__minutes');
    var s = el.querySelector('.flash-countdown__seconds');

    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(minutes);
    if (s) s.textContent = pad(seconds);
  }

  function initCountdowns() {
    var countdowns = document.querySelectorAll('.flash-countdown');
    countdowns.forEach(function (el) {
      var endDateStr = el.dataset.endDate;
      var targetDate = getTargetDate(endDateStr);

      // Nesne referansı — clearInterval için ID'yi callback içinde okumak gerekiyor
      var handle = { id: null };
      updateCountdown(el, targetDate, handle);
      handle.id = setInterval(function () {
        updateCountdown(el, targetDate, handle);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }
})();
